import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { ApiService } from "../../services/apiService";

export const fetchfeatures = createAsyncThunk<
  any,
  { page: number; limit: number }
>("features", async ({ page, limit }, { rejectWithValue }) => {
  try {
    const features = await ApiService.get<any>(
      `/features?page=${page}&limit=${limit}`
    );
    return features?.data || [];
  } catch (error) {
    return rejectWithValue(
      (error as any).message || "Failed to fetch features"
    );
  }
});
export const fetchfeaturesOptions = createAsyncThunk(
  "featuresoptions",
  async (_, { rejectWithValue }) => {
    try {
      const features = await ApiService.get<any>(`/features?page=1&limit=100`);
      return features?.data || [];
    } catch (error) {
      return rejectWithValue(
        (error as any)?.message || "Failed to fetch features"
      );
    }
  }
);

interface AddFeaturePayload {
  name: string;
  description: string;
  status: number;
  slug: string;
  type: number;
}
interface UpdateFeaturePayload {
  id: string;
  data: AddFeaturePayload;
}

export const addFeature = createAsyncThunk<
  any, // return type (replace with proper API response type)
  AddFeaturePayload, // argument type
  { rejectValue: string }
>("features/addFeature", async (data, { rejectWithValue }) => {
  try {
    const response = await ApiService.post(`/add-feature`, data);

    return response;
  } catch (error) {
    return rejectWithValue((error as any)?.message || "Failed to add feature");
  }
});
export const UpdateFeature = createAsyncThunk<
  any, // return type (replace with proper API response type)
  UpdateFeaturePayload,
  { rejectValue: string }
>("features/updateFeature", async ({ data, id }, { rejectWithValue }) => {
  try {
    const response = await ApiService.put(`/update-feature/${id}`, data);

    return response;
  } catch (error) {
    return rejectWithValue((error as any)?.message || "Failed to add feature");
  }
});
export const DeleteFeature = createAsyncThunk<
  any, // return type (replace with proper API response type)
  number,
  { rejectValue: string }
>("features/delete", async (id, { rejectWithValue }) => {
  try {
    const response = await ApiService.delete(`/delete-feature/${id}`);

    return response;
  } catch (error) {
    return rejectWithValue((error as any)?.message || "Failed to add feature");
  }
});

interface UpdateFeatureStatusPayload {
  updates: Array<{
    id: number;
    platform_type: {
      android: boolean;
      ios: boolean;
      web: boolean;
    };
  }>;
}

export const updateFeatureStatus = createAsyncThunk<
  any,
  UpdateFeatureStatusPayload,
  { rejectValue: string }
>("features/updateFeatureStatus", async (data, { rejectWithValue }) => {
  try {
    const response = await ApiService.put(`/update-feature-status`, data);
    return response;
  } catch (error) {
    return rejectWithValue((error as any)?.message || "Failed to update feature status");
  }
});

const featureManagementSlice = createSlice({
  name: "features",
  initialState: {
    features: [] as any,
    isLoading: false,
    pagination: {},
    counts: {},
    isOptionLoading: false,
    featuresList: [] as any,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchfeatures.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchfeatures.fulfilled, (state, action) => {
        state.isLoading = false;
        state.features = action?.payload?.items;
        state.pagination = action?.payload?.pagination;
        state.counts = action?.payload?.counts;
      })
      .addCase(fetchfeatures.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(fetchfeaturesOptions.pending, (state) => {
        state.isOptionLoading = true;
      })
      .addCase(fetchfeaturesOptions.fulfilled, (state, action) => {
        state.isOptionLoading = false;
        state.featuresList = action?.payload?.items;
      })
      .addCase(fetchfeaturesOptions.rejected, (state, action) => {
        state.isOptionLoading = false;
      });
  },
});

export default featureManagementSlice.reducer;
